// Application specific configuration variables
// potentially sourced from process.env.REACT_APP_*
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL as string) || "";

export const ERROR_DURATION_MS = 5000;

export const CDN_URL = "https://sos-ch-gva-2.exo.io/optimizer-cdn";
